import React from 'react'

import noop from 'lodash/noop'

import cn from '../../libs/class-names'

import closeIcon from '../../assets/icons/close.svg'
import searchIcon from '../../assets/icons/search.svg'

import Icon from '../icon'

export interface Props {
  classNames?: string[]
  onChange?: (
    value: string,
    name: string | undefined,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void
  onClearClick?: () => void
  value?: string
  id?: string
  name?: string
  placeholder?: string
  disabled?: boolean
  tiny?: boolean
}
const SearchField = ({
  classNames,
  onChange = noop,
  onClearClick = noop,
  value = '',
  id,
  name,
  placeholder,
  disabled = false,
  tiny = false,
}: Props) => {
  const hasValue = !!(value && value.length > 0)

  return (
    <div className={cn('SearchField', {disabled, tiny, hasValue}, classNames)}>
      <input
        id={id}
        name={name}
        className="SearchField__input"
        type="text"
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={event => onChange(event.target.value, name, event)}
      />
      <button type="button" className="SearchField__clear" onClick={onClearClick}>
        <Icon source={closeIcon} title="Clear" block />
      </button>
      <span className="SearchField__search" aria-hidden>
        <Icon source={searchIcon} block />
      </span>
    </div>
  )
}

export default SearchField
